import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Trash2, MailOpen, MessageSquare, Heart } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [kind, setKind] = useState("all");
  const [items, setItems] = useState([]);

  const load = () => {
    const params = kind === "all" ? {} : { kind };
    api.get("/messages", { params }).then((r) => setItems(r.data)).catch(() => {});
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind]);

  const markRead = async (id) => {
    await api.put(`/messages/${id}/read`);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    await api.delete(`/messages/${id}`);
    toast.success("Message supprimé");
    load();
  };

  return (
    <div data-testid="admin-messages">
      <div className="mb-8">
        <div className="text-gold-dark text-xs tracking-[0.3em] uppercase">Boîte de réception</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-deepblue-900 mt-1">Messages & prières</h1>
      </div>

      <Tabs value={kind} onValueChange={setKind}>
        <TabsList data-testid="messages-tabs">
          <TabsTrigger value="all">Tous</TabsTrigger>
          <TabsTrigger value="contact"><MessageSquare className="w-3.5 h-3.5 mr-1.5" />Contact</TabsTrigger>
          <TabsTrigger value="prayer"><Heart className="w-3.5 h-3.5 mr-1.5" />Prière</TabsTrigger>
        </TabsList>

        <TabsContent value={kind} className="mt-6 space-y-4">
          {items.length === 0 && (
            <div className="text-center py-16 text-slate-400 bg-white rounded-2xl border border-slate-200">
              Aucun message
            </div>
          )}
          {items.map((m) => (
            <div key={m.id} className={`rounded-2xl border p-6 bg-white ${!m.is_read ? "border-gold shadow-md" : "border-slate-200"}`} data-testid={`message-${m.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded ${m.kind === "prayer" ? "bg-pink-100 text-pink-700" : "bg-blue-100 text-blue-700"}`}>
                      {m.kind === "prayer" ? "Prière" : "Contact"}
                    </span>
                    {!m.is_read && <span className="text-[10px] uppercase tracking-widest px-2 py-0.5 rounded bg-gold text-white">Nouveau</span>}
                    <span className="text-xs text-slate-400">{new Date(m.created_at).toLocaleString("fr-FR")}</span>
                  </div>
                  <div className="mt-2 font-serif text-lg text-deepblue-900">{m.subject}</div>
                  <div className="text-sm text-slate-500">
                    {m.name} · <a href={`mailto:${m.email}`} className="text-gold-dark hover:underline">{m.email}</a>
                    {m.phone && <> · {m.phone}</>}
                  </div>
                  <p className="mt-3 text-slate-700 whitespace-pre-wrap">{m.body}</p>
                </div>
                <div className="flex flex-col gap-2">
                  {!m.is_read && (
                    <Button size="sm" variant="outline" onClick={() => markRead(m.id)} data-testid={`mark-read-${m.id}`}>
                      <MailOpen className="w-4 h-4 mr-1" /> Marquer lu
                    </Button>
                  )}
                  <Button size="sm" variant="ghost" onClick={() => remove(m.id)}>
                    <Trash2 className="w-4 h-4 text-red-600" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
